import { h } from 'preact';

import { Button } from '../button';

export const Modal = (props) => {
  const { visible = false, headerText = '', bodyJSX = '', footerButtons = [], width = '', showBackdrop = true, closeCallback, inContainer = true } = props;
  const classes = ['vf', 'modal'];

  if (!showBackdrop) {
    classes.push('no-backdrop');
  }
  if (inContainer) {
    classes.push('in-container');
  }

  return (
    <div class={classes.join(' ')} style={visible ? '' : 'display: none;'}>
      <div class="modal-content" style={width ? `width: ${width}` : ''}>
        {headerText && <div class="modal-header">
          <h4>{headerText}{closeCallback && <Button className="modal-close" icon="fa-close" onClick={closeCallback} />}</h4>
        </div>}
        <div class="modal-body">
          {!headerText && closeCallback && <i class="fa fa-close modal-close" onClick={closeCallback} />}
          {bodyJSX}
        </div>
        <div class="modal-footer">
          {footerButtons.map((btn, key) => {
            return <button key={key} id={btn.id} class={btn.primary ? 'primary' : ''} onClick={btn.callback} type="button">{btn.label}</button>
          })}
        </div>
      </div>
    </div>
  )
};
